import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Monitor, Smartphone, ArrowRight } from 'lucide-react';
import AppFooter from '../../components/AppFooter';
import '../../styles/staffing-theme.css';

export default function StaffingLanding() {
  useEffect(() => {
    const prev = document.title;
    document.title = 'Talent Connect — SignVoice';
    return () => { document.title = prev; };
  }, []);

  return (
    <div className="staffing-theme staffing-theme--with-topnav staffing-landing" data-testid="staffing-landing">
      <div className="staffing-landing-bg" aria-hidden="true" />

      <header className="staffing-landing-header">
        <Link to="/" className="staffing-back-link" data-testid="back-to-consumer">← SignVoice Consumer</Link>
        <span className="staffing-phase-tag">PHASE 3 · TALENT CONNECT</span>
      </header>

      <main className="staffing-landing-main">
        <p className="staffing-eyebrow">SignVoice · Talent Connect</p>
        <h1 className="staffing-landing-title">
          Welcome to <span className="tc-glow">Talent Connect</span>
        </h1>
        <p className="staffing-landing-tagline">Your AI Partner for Inclusive Hiring</p>
        <p className="staffing-landing-sub">
          Real-time ASL pre-qualification for warehouse hiring. The recruiter
          generates a QR code on the tablet; the candidate scans it and answers
          three short questions in ASL.
        </p>

        <div className="staffing-landing-cards">
          <Link to="/talent-connect/recruiter" className="staffing-landing-card" data-testid="landing-recruiter">
            <Monitor className="staffing-landing-icon" />
            <h3>I'm the Recruiter</h3>
            <p>Generate a QR code and watch the candidate answer in real time.</p>
            <span className="staffing-landing-cta">Open Recruiter Dashboard <ArrowRight className="w-4 h-4" /></span>
          </Link>

          <div className="staffing-landing-card staffing-landing-card--info" data-testid="landing-candidate-hint">
            <Smartphone className="staffing-landing-icon" />
            <h3>I'm the Candidate</h3>
            <p>Scan the QR code on the recruiter's tablet to join the session. Your
            unique room URL will be on that screen.</p>
            <span className="staffing-landing-cta staffing-landing-cta--muted">Wait for the recruiter</span>
          </div>
        </div>
      </main>
      <AppFooter />
    </div>
  );
}
